import { OnboardingActionTypes } from './onboarding.types';

const onboardingRegisterRequest = ({
  hostingId, origin, domain, skip = false,
}) => ({
  type: OnboardingActionTypes.ONBOARDING_REGISTER_REQUEST,
  payload: {
    hostingId, origin, domain, skip,
  },
});
const onboardingRegisterSuccess = ({ builderId }) => ({ type: OnboardingActionTypes.ONBOARDING_REGISTER_SUCCESS, payload: { builderId } });
const onboardingRegisterFailure = () => ({ type: OnboardingActionTypes.ONBOARDING_REGISTER_FAILURE });

const onboardingUpdateRequest = ({
  hostingId, origin, domain, builder, finished, step,
}) => ({
  type: OnboardingActionTypes.ONBOARDING_UPDATE_REQUEST,
  payload: {
    hostingId, origin, domain, builder, finished, step,
  },
});
const onboardingUpdateSuccess = () => ({ type: OnboardingActionTypes.ONBOARDING_UPDATE_SUCCESS });
const onboardingUpdateFailure = () => ({ type: OnboardingActionTypes.ONBOARDING_UPDATE_FAILURE });

const wizardRegisterRequest = ({
  domain, origin,
}) => ({
  type: OnboardingActionTypes.WIZARD_REGISTER_REQUEST,
  payload: {
    domain, origin,
  },
});
const setWizardRegister = ({ wizardId }) => ({
  type: OnboardingActionTypes.SET_WIZARD_REGISTER,
  payload: {
    wizardId,
  },
});
const wizardRegisterSuccess = () => ({ type: OnboardingActionTypes.WIZARD_REGISTER_SUCCESS });
const wizardRegisterFailure = () => ({ type: OnboardingActionTypes.WIZARD_REGISTER_FAILURE });

const wizardUpdateRequest = ({
  wizardId, domain, origin, builder, finished,
}) => ({
  type: OnboardingActionTypes.WIZARD_UPDATE_REQUEST,
  payload: {
    wizardId, domain, origin, builder, finished,
  },
});
const wizardUpdateSuccess = preventChangeStart => ({ type: OnboardingActionTypes.WIZARD_UPDATE_SUCCESS, payload: { preventChangeStart } });
const wizardUpdateFailure = () => ({ type: OnboardingActionTypes.WIZARD_UPDATE_FAILURE });

const resetOnboarding = () => ({
  type: OnboardingActionTypes.RESET_ONBOARDING,
});

const requestBusinessListBuilder = query => ({ type: OnboardingActionTypes.BUSINESS_LIST_BUILDER_REQUEST, payload: { query } });
const setBusinessListBuilder = data => ({ type: OnboardingActionTypes.BUSINESS_LIST_BUILDER_SET, payload: { data } });
const successBusinessListBuilder = () => ({ type: OnboardingActionTypes.BUSINESS_LIST_BUILDER_SUCCESS });
const failureBusinessListBuilder = () => ({ type: OnboardingActionTypes.BUSINESS_LIST_BUILDER_FAILURE });

const requestSitebuilderTemplates = ({
  page = 1, count = 20, category,
}) => ({
  type: OnboardingActionTypes.REQUEST_SITEBUILDER_TEMPLATES,
  payload: {
    page, count, category,
  },
});

const setSitebuilderTemplates = ({ templates, pagination }) => ({
  type: OnboardingActionTypes.SET_SITEBUILDER_TEMPLATES,
  payload: {
    templates,
    pagination,
  },
});

const setSitebuilderTemplatesLoading = isLoading => ({
  type: OnboardingActionTypes.SET_SITEBUILDER_TEMPLATES_LOADING,
  payload: { isLoading },
});

const setSitebuilderTemplatesSuccess = () => ({ type: OnboardingActionTypes.SET_SITEBUILDER_TEMPLATES_SUCCESS });
const setSitebuilderTemplatesFailure = () => ({ type: OnboardingActionTypes.SET_SITEBUILDER_TEMPLATES_FAILURE });
const resetSitebuilderTemplatesState = () => ({ type: OnboardingActionTypes.RESET_SITEBUILDER_TEMPLATES_STATE });

const requestSitebuilderCategories = () => ({
  type: OnboardingActionTypes.REQUEST_SITEBUILDER_CATEGORIES,
});

const setSitebuilderCategories = categories => ({
  type: OnboardingActionTypes.SET_SITEBUILDER_CATEGORIES,
  payload: {
    categories,
  },
});

const setSitebuilderCategoriesLoading = isLoading => ({
  type: OnboardingActionTypes.SET_SITEBUILDER_CATEGORIES_LOADING,
  payload: { isLoading },
});

const setSitebuilderCategoriesSuccess = () => ({ type: OnboardingActionTypes.SET_SITEBUILDER_CATEGORIES_SUCCESS });
const setSitebuilderCategoriesFailure = () => ({ type: OnboardingActionTypes.SET_SITEBUILDER_CATEGORIES_FAILURE });

const requestSitebuilderProvisioning = ({ hostingId, callback }) => ({
  type: OnboardingActionTypes.REQUEST_SITEBUILDER_PROVISIONING,
  payload: { hostingId, callback },
});

const setSitebuilderProvisioning = ({ builderAddonId }) => ({
  type: OnboardingActionTypes.SET_SITEBUILDER_PROVISIONING,
  payload: { builderAddonId },
});

const setSitebuilderProvisioningFailure = () => ({ type: OnboardingActionTypes.SET_SITEBUILDER_PROVISIONING_FAILURE });
const resetSitebuilderProvisioning = () => ({ type: OnboardingActionTypes.RESET_SITEBUILDER_PROVISIONING });

const registerClmEvent = ({ action, finished }) => ({
  type: OnboardingActionTypes.REGISTER_CLM_EVENT,
  payload: { action, finished },
});

const actions = {
  onboarding: {
    reset: resetOnboarding,
    register: {
      request: onboardingRegisterRequest,
      success: onboardingRegisterSuccess,
      failure: onboardingRegisterFailure,
    },
    update: {
      request: onboardingUpdateRequest,
      success: onboardingUpdateSuccess,
      failure: onboardingUpdateFailure,
    },
  },
  wizard: {
    register: {
      request: wizardRegisterRequest,
      set: setWizardRegister,
      success: wizardRegisterSuccess,
      failure: wizardRegisterFailure,
    },
    update: {
      request: wizardUpdateRequest,
      success: wizardUpdateSuccess,
      failure: wizardUpdateFailure,
    },
  },
  sitebuilder: {
    provisioning: {
      request: requestSitebuilderProvisioning,
      set: setSitebuilderProvisioning,
      failure: setSitebuilderProvisioningFailure,
      reset: resetSitebuilderProvisioning,
    },
    business: {
      request: requestBusinessListBuilder,
      success: successBusinessListBuilder,
      failure: failureBusinessListBuilder,
      set: setBusinessListBuilder,
    },
    templates: {
      request: requestSitebuilderTemplates,
      set: setSitebuilderTemplates,
      setLoading: setSitebuilderTemplatesLoading,
      success: setSitebuilderTemplatesSuccess,
      failure: setSitebuilderTemplatesFailure,
      resetState: resetSitebuilderTemplatesState,

      categories: {
        request: requestSitebuilderCategories,
        set: setSitebuilderCategories,
        setLoading: setSitebuilderCategoriesLoading,
        success: setSitebuilderCategoriesSuccess,
        failure: setSitebuilderCategoriesFailure,
      },
    },
  },
  clmEvent: {
    registerClmEvent,
  },
};

export default actions;
